/* eslint-disable quotes */
export default Object.freeze({
  //==>BatchConfirm
  COLLECTIVE_PRODUCT_REVIEW: '일괄 상품심사',
  SELECTED: '선택하신',
  REVIEW_IS_CONDUCTED_FOR_THE_PRODUCT: '건 상품에 대해 일괄 상품심사를 진행합니다.',
  PRODUCT_REVIEW: '상품심사',
  SALES_APPROVAL: '판매승인',
  REJECTION_OF_APPROVAL: '승인거부',
  REGISTRATION_OF_APPROVAL: '승인거부 의견 등록',
  SEPARATE_APPROVAL: '별도 승인거부 의견',
  AMENDMENT_REQUEST: '수정요청',
  PLEASE_ENTER_YOUR: '승인거부의견을 입력해주세요',
  CONFIRM: '확인',
  CANCEL: '취소',

  REGISTER_PRICE_COMPARISON_SITE: '가격비교사이트 등록',
  DO_NOT_REGISTER: '등록 안함',
  ENROLLMENT: '등록',
  SELECT_ALL: '전체선택',
  NAVER_SHOPPING: '네이버쇼핑',
  FACEBOOK: '페이스북',
  OVERCHARGE: '에누리',
  DANAWA: '다나와',
  KUCHA: '쿠차',
  WONDER: '위메프원더쇼핑',
  // CONFIRM: '확인'
  // CANCEL: '취소',

  //==>CopyMallProduct
  PRODUCT_COPY: '상품복사',
  SELECTED_PRODUCT_NUMBER: '선택하신 상품번호',
  COPY_THE_PRODUCT: '상품을 복사합니다.',
  PLEASE_SELECT_THE_PRODUCT: '상품복사 유형을 선택해주세요.',
  WHEN_SELECTING_DO_NOT_LINK_: '재고수량 연동 안함 선택 시: 재고수량 복사 여부 선택 가능합니다.',
  WHEN_SELECTING_INVENTORY_: '재고수량 연동 선택 시: 상품평 복사 여부 선택 가능합니다.',
  SELECT_SHOPPING_MALL: '쇼핑몰선택',
  STOCK_QUANTITY_LINKAGE: '재고수량 연동',
  DO_NOT_LINK_INVENTORY_QUANTITY: '재고수량 연동 안함',
  // STOCK_QUANTITY_LINKAGE: '재고수량 연동',
  IN_CASE_OF_SETTING_THE_STOCK: '재고수량 연동으로 설정할 경우',
  WHEN_A_SALE_OCCURS_ON_A_COPIED: '- 복사된 상품에서 판매가 발생하면 복사한 상품의 재고수량이 차감됩니다.',
  HOWEVER_THE_ACTUAL_SALES: '단, 2개 상품의 실제 판매수량은 별도 관리됩니다.',
  COPY_STOCK_QUANTITY: '재고수량 복사',
  DO_NOT_COPY: '복사 안함',
  COPY: '복사',
  COPY_STOCK_QUANTITY2: '재고수량 복사: 복사할 상품과 재고연동 없이 재고수량만 복사',
  COPY_PRODUCT_REVIEW: '상품평 복사',
  // DO_NOT_COPY: '복사 안함',
  // COPY: '복사',
  // PRODUCT_COPY: '상품복사',
  // CANCEL: '취소',

  //==>CustomProperty
  INFORMATION: '정보',
  CLOSE: '닫기',

  //==>ModifyDelivery
  DELIVERY_SPECIFIED_DATE_APPLIED: '배송지정일 적용',
  DELIVERY_SPECIFIED_DATE: '배송지정일',
  NOT_SET: '설정안함',
  SETTINGS: '설정',
  TERM: '기간',
  // NOT_SET: '설정안함',
  // SETTINGS: '설정',
  DAY_OF_THE_WEEK: '요일',
  // SELECT_ALL: '전체선택',
  MONTH: '월',
  ANGER: '화',
  NUMBER: '수',
  NECK: '목',
  GOLD: '금',
  BASED_ON_ORDER_DATE: '주문일 기준',
  // NOT_SET: '설정안함',
  // SETTINGS: '설정',
  THE_DELIVERY_DATE_PERIODORDATE_IS_CALCULATED: '배송지정일 기간/일자는 영업일 기준으로 계산하여 설정 됩니다.',
  // CONFIRM: '확인',
  // CANCEL: '취소',
  FROM: '부터',
  WORK: '일',

  //==>DisplayCategoryInfo
  EXHIBITION_CATEGORY_INFORMATION: '전시카테고리 정보',
  // CLOSE: '닫기',

  //==>EditImages
  IMAGE_INFORMATION: '이미지 정보',
  PRODUCT_IMAGE: '상품 이미지',
  PLEASE_REGISTER_A_REPRESENTATIVE: '대표이미지를 등록해주세요.',
  WHEN_PRODUCT_IMAGES_ARE_REGISTERED:
    '상품이미지 등록 시 자동으로 리스트, 확대, 고정 이미지에 리사이징되어 전시됩니다. (추가이미지 최대 {count}개 등록가능)',
  LIST_IMAGE: '리스트 이미지',
  // LIST_IMAGE: '리스트 이미지',
  RECOMMENDED_720X400: '권장 720x400',
  PRODUCT_DETAILS_TOP: '상품 상세(상단)',
  // DO_NOT_REGISTER: '등록 안함',
  // ENROLLMENT: '등록',
  PLEASE_REGISTER_PRODUCT_DETAILS: '상품상세 항목을 등록해주세요.',
  PRODUCT_DETAILS: '상품 상세',
  DIRECT_IMAGE_REGISTRATION: '이미지 직접등록',
  USE_REGISTERED_OPTION_IMAGE: '등록된 옵션이미지 사용',
  // PLEASE_REGISTER_PRODUCT_DETAILS: '상품상세 항목을 등록해주세요.',
  PRODUCT_DETAILS_BOTTOM: '상품 상세(하단)',
  // DO_NOT_REGISTER: '등록 안함',
  // ENROLLMENT: '등록',
  PLEASE_REGISTER_A_REPRESENTATIVE_IMAGE: '대표이미지를 등록해주세요.',
  SAVE: '저장',
  // CANCEL: '취소',
  EIMAGEMSG1: '이미지파일(Jpg,jpge,gif,png,bmp)만 등록해주세요.',
  EIMAGEMSG2: '해당 상품에 등록된 옵션 이미지가 없습니다.',
  EIMAGEMSG3: '입력 불가한 항목이 있습니다. 다시확인해주세요.',
  EIMAGEMSG4: '이미지 정보 수정이 완료되었습니다.',
  EIMAGEMSG5: '이미지 정보 수정이 실패했습니다.',

  //==>modifyFrontDisplay
  EXHIBITION_STATUS: '전시상태',
  // SELECTED: '선택하신',
  CHANGES_THE_DISPLAY_STATUS_OF: '건 상품에 대해 전시상태를 일괄 변경합니다.',
  CHANGE_OF_EXHIBITION_STATUS: '전시상태 변경',
  // CHANGE_OF_EXHIBITION_STATUS: '전시상태 변경',
  DISPLAY_POSSIBLE: '전시가능',
  NO_EXHIBITION: '전시안함',
  // CONFIRM: '확인',
  // CANCEL: '취소',
  PLEASE_ENTER_A_VALUE: '값을 입력해주세요',

  //==>ModifyImmediateDiscount
  INSTANT_DISCOUNT_SETTING: '즉시할인 설정',
  // SELECTED: '선택하신',
  INSTANT_DISCOUNT_IS_SET_COLLECTIVELY: '건 상품에 대해 즉시할인을 일괄 설정합니다.',
  IMMEDIATE_DISCOUNT: '즉시할인',
  PERIOD_SETTING: '기간설정',
  // CONFIRM: '확인',
  // CANCEL: '취소',
  WON: '원',
  DAYS_3: '3일',
  DAYS_7: '7일',
  DAYS_15: '15일',
  DAYS_30: '30일',
  DAYS_60: '60일',
  DAYS_90: '90일',
  THE_PRICE_IN_UNITS_OF_10_WON: '가격은 10원 단위로 입력 가능합니다.',
  THE_PRICE_FOR_LESS_THAN_1_BILLION_WON: '가격은 10억원 미만으로 입력 가능합니다.',
  // PLEASE_ENTER_A_VALUE: '값을 입력해주세요',

  //==>ModifyPromotion
  APPLY_PROMOTION: '프로모션 적용',
  PROMOTION: '프로모션',
  POSSIBLE: '가능',
  ADDITIONAL_DISCOUNT: '추가할인',
  COUPON: '쿠폰',
  FREE_GIFT: '사은품',
  IMPOSSIBLE: '불가능',
  PARTNER_PROMOTION_AGREE: '프로모션 동의여부',
  PARTNER: '파트너사',
  AGREE: '동의함',
  DISAGREE: '동의안함',
  // CONFIRM: '확인',
  // CANCEL: '취소',

  //==>ModifyPromotionText
  CHANGE_OF_PROMOTIONAL_TEXT: '홍보문구 변경',
  // SELECTED: '선택하신',
  TEXT_FOR_THE_PRODUCT_IS_CHANGED_COLLECTIVELY: '건 상품에 대해 홍보문구를 일괄 변경합니다.',
  PR_TEXT: '홍보문구',
  // PERIOD_SETTING: '기간설정',
  // CONFIRM: '확인',
  // CANCEL: '취소',
  ENTER_PROMOTIONAL_TEXT: '홍보문구 입력',

  //==>ModifySalePeriod
  CHANGE_OF_SALES_PERIOD: '판매기간 변경',
  // SELECTED:'선택하신',
  CHANGES_THE_SALES_PERIOD_FOR: '건 상품에 대한 판매기간을 일괄 변경합니다.',
  SALES_PERIOD: '판매기간',
  ALWAYS_ON_SALE: '상시 판매',
  PERIOD_DESIGNATED_SALES: '기간지정 판매',
  // CONFIRM: '확인',
  // CANCEL:'취소',

  //==>ModifySalePrice
  ENTER_ONLY_NUMBERS: '숫자만 입력',
  CHANGE_IN_SELLING_PRICE: '판매가 변경',
  // SELECTED: '선택하신',
  COLLECTIVELY_CHANGE_THE_SELLING_PRICE: '건 상품에 대해 판매가를 일괄 변경합니다.',
  IN_THE_CASE_OF_CHARACTERISTIC_PRODUCTS: '특성상품의 경우 판매가 변경이 불가능할 수 있습니다.',
  ALSO_IF_YOU_CHANGE_THE_SELLING_PRICE:
    '또한, 옵션이 등록된 상품의 판매가를 변경하실 경우 옵션 별 실제 판매가가 변경됩니다.',
  CHANGE_PRICE: '변경할 판매가',
  AT_THE_CURRENT_SELLING_PRICE: '현재 판매가에서',
  // CONFIRM: '확인',
  // CANCEL: '취소',
  IMPRESSION: '인상',
  CUT: '인하',
  CHANGE_TO: '으로 변경',
  PRICE_IN_UNITS_OF_10_WON: '가격은 10원 단위로 입력 가능합니다',
  // PLEASE_ENTER_A_VALUE: '값을 입력해주세요',

  //==>ModifySaleStatus
  CHANGE_OF_SALES_STATUS: '판매설정 변경',
  // SELECTED: '선택하신',
  CHANGES_THE_SALES_STATUS_OF: '건 상품에 대해 판매상태를 일괄 변경합니다.',
  PRODUCTS_THAT_HAVE_BEEN_BANNED_FOR: '판매금지로 변경 된 상품은 판매제개가 불가능하니 신중히 변경해주세요.',
  WHEN_IT_IS_CHANGED_TO_PROHIBITED_FOR: `판매금지로 변경 시에 전시상태는 '전시안함'으로 자동 변경됩니다.`,
  WHEN_CHANGING_A_DISCONTINUED_PRODUCT: `판매중지 상품을 판매중으로 변경 시 전시상태도 '전시가능'으로 변경해야 상품이 노출됩니다.`,
  DEPENDING_ON_THE_PRE_ORDER_PERIOD: '예약판매기간과 판매기간에 따라 예약판매중 또는 판매중으로 변경합니다.',
  SALES_STATUS: '판매상태',
  SALES_STATUS_NEW: '판매설정',
  // CONFIRM: '확인',
  // CANCEL: '취소',
  // CHANGE_OF_SALES_STATUS: '판매상태 변경',
  ON_SALEORON_RESERVATION_SALE: '판매가능', //'판매중/예약판매중',
  STOP_SELLING: '판매중지',
  PROHIBITION_OF_SALE: '판매금지',
  IF_YOU_CHANGE_TO_PROHIBITION_OF_SALES:
    '판매금지로 변경 할 경우 판매재개가 불가능합니다. 판매금지로 변경하시겠습니까?',
  // PLEASE_ENTER_A_VALUE: '값을 입력해주세요',

  //==>UrlDirectDisplay
  FRONT_UNEXPOSED_SETTING: '프론트 미노출 설정',
  YOU_CAN_COLLECTIVELY_CHANGE_WHETHER: `상품에 설정된 '프론트 미노출' 여부를 일괄 변경할 수 있습니다.`,
  IT_IS_NOT_EXPOSED_IN_THE_EXHIBITION: '‘프론트 미노출’ 설정 시, ‘전시카테고리’ 및 ‘검색영역’ 에 노출되지 않습니다.',
  FRONT_UNEXPOSED: '프론트 미노출',
  // FRONT_UNEXPOSED_SETTING: '프론트 미노출 설정',
  // FRONT_UNEXPOSED: '프론트 미노출',
  FRONT_EXPOSURE: '프론트 노출',
  // SAVE: '저장',
  // CLOSE: '닫기',

  PROMOTIONS: '프로모션',
  PROMOTIONS_CHANGE: '프로모션 일괄변경',
  PROMOTION_CHANGE_NOTICE01: '건의 상품에 대해 프로모션 적용 설정을 일괄 변경합니다.',
  PROMOTION_CHANGE_NOTICE02: '기존 상품에 적용한 프로모션 설정이 모두 변경됩니다.',
  PROMOTION_CHANGE_NOTICE03:
    '상품별 프로모션 가능여부 설정을 "가능"으로 설정하더라도 파트너사 프로모션 동의여부가 "동의 안 함"일 경우 프로모션 적용이 불가합니다.',
  PROMOTION_CHANGE_NOTICE04: '(리스트에서도 적용여부 "N"으로 표기)',
  PROMOTION_SETTING: '프로모션 적용 설정',
  PROMOTION_AVAILABLE: '프로모션 가능',
  PROMOTION_NOT_AVAILABLE: '프로모션 불가능',

  //ModifyDeliver.vue
  MD_CHANGE_DELIVERY_INFORMATION: '배송정보 변경',
  MD_SELECTED: '선택하신',
  MD_KEY: '건',
  MD_CHANGE_THE_SHIPPING_INFORMATION_FOR: '상품에 대해 배송정보를 일괄 변경합니다.',
  MD_DELIVERY_STATUS: '배송여부',
  MD_DELIVERY: '배송',
  MD_NO_DELIVERY: '배송안함',
  MD_SHIPPING_CLASSIFICATION: '배송구분',
  MD_PARTNER_DELIVERY: '파트너사 배송',
  MD_SHOPPING_MALL_SHIPPING: '쇼핑몰 배송',
  MD_DELIVERY_SPECIFIED_DATE: '배송지정일',
  MD_NOT_SET: '설정안함',
  MD_SET: '설정',
  MD_TERM: '기간',
  // MD_NOT_SET: '설정안함',
  // MD_SET: '설정',
  MD_DAY_OF_THE_WEEK: '요일',
  MD_SELECT_ALL: '전체선택',
  MD_MONTH: '월',
  MD_ANGER: '화',
  MD_NUMBER: '수',
  MD_NECK: '목',
  MD_GOLD: '금',
  MD_BASED_ON_ORDER_DATE: '주문일 기준',
  // MD_NOT_SET: '설정안함',
  // MD_SET: '설정',
  MD_FROM: '부터',
  MD_THE_SPECIFIED_DELIVERY_DATE_PERIOD: '배송지정일 기간/일자는 영업일 기준으로 계산하여 설정 됩니다.',
  MD_BUNDLE_DELIVERY_AVAILABILITY: '묶음배송 가능여부',
  MD_BUNDLE_DELIVERY_IS_NOT_POSSIBLE: '묶음배송 불가능 (상품별 배송비 적용)',
  MD_OVERSEAS_DELIVERY: '해외배송 여부',
  MD_OVERSEAS_DELIVERY_PRODUCTS: '해외배송상품 (해외 -> 대한민국으로 배송되는 상품)',
  MD_SHIPPING_TEMPLATE_LIST: '배송 템플릿 목록',
  MD_SHIPPING_TEMPLATE_MANAGEMENT: '배송템플릿 관리',
  MD_SHIPPING_METHOD: '배송방법',
  MD_SHIPPING_COST_TYPE: '배송비유형',
  MD_SHIPPING_FEE: '배송비',
  MD_WON: '원',
  MD_SHIPPING_ADDRESS: '출고지 주소',
  MD_EXCHANGE_ADDRESS: '반품/교환지 주소',
  MD_EXCHANGE_SHIPPING_FEE: '반품/교환지 배송비',
  MD_ONE_WAY_STANDARD: '편도기준',
  MD_SELLERS_SPECIFICS: '판매자 특이사항',
  MD_CUSTOMER_INFORMATION: '고객안내사항',
  MD_DO_NOT_REGISTER: '등록 안함',
  MD_ENROLLMENT: '등록',
  MD_CONFIRM: '확인',
  MD_CANCEL: '취소',
  MD_EXPRESS: '대한통운',
  MD_HELP_TEXT1: '반품/교환배송비 가이드',
  MD_HELP_TEXT2:
    '반품/교환 배송비를 0원으로 입력하는 경우 무료반품/교환으로 설정되니 금액을 정확히 확인하시기 바랍니다.',
  MD_HELP_TEXT3:
    '구매자가 반품/교환 신청 시 계산되는 반품/교환 택배비는 초도배송비와 반품/교환배송비의 합계 금액입니다.',
  MD_HELP_TEXT4: '초도배송비 2,500원(상품구매시 구매자가 이미 지불) + 반품배송비 3,000원 = 반품택배비 5,500원',
  MD_HELP_TEXT5: '초도배송비 무료 + 반품배송비 3,000원 = 반품택배비 6,000원 (초도배송비가 무료 일 경우 반품배송비 * 2)',

  //=>ChangeAdmin
  CHANGE_ADMIN: '담당자 변경',
  CHANGE_ADMIN_DIALOGUES: `
    담당자 변경 시 상품 재심사 대상이 되어 승인 처리가 필요합니다.
    수정 후 승인대기 상품을 담당자 변경할 경우 기존 수정사항이 삭제되니 승인처리 후 변경하시기 바랍니다.
    선택한 쇼핑몰의 상품만 담당자 일괄변경 가능하며, 판매금지 상품은 변경이 불가능합니다.
    변경 처리 중 담당자 권한이 변경 될 경우 실패처리 되오니, 중간에 권한이 변경되지 않도록 주의하세요.
  `,
  UPLOAD_FORM: '업로드 양식',
  EXCEL_UPLOAD: '엑셀 업로드',
  CHANGE_PRODUCT_ADMIN_EXCEL_FORM_NAME: '상품담당자변경',
  ALERT_ADMIN_CHANGE_COMPLETE: '담당자 변경이 완료되었습니다.',
  FAILED_CHANGE_PRODUCT_ADMIN_EXCEL_NAME: '상품담당자변경_실패결과',
  MESSAGE_UPLOADING_ADMIN_EXCEL:
    '변경 진행중입니다. 대상 상품이 많을 경우 다소 시간이 소요됩니다.<br>팝업을 닫더라도 요청하신 담당자 변경은 진행되나,<br>변경 완료 시 결과를 안내해드리므로 팝업을 닫지 말아주세요.',
  //=> ModifySalePriceAndImmediateDiscount.vue
  MSBATCH_CHANGE_OF_SELLING_PRICEIMMEDIATE: '판매가/즉시할인 일괄변경',
  MSYOU_CAN_COLLECTIVELY_CHANGE_THE_SELLING: '복수 상품의 판매가와 즉시할인을 엑셀파일 업로드로 일괄 변경 가능합니다.',
  MSFOR_CERTAIN_PRODUCTS_THE_SALE_PRICE: '특정상품의 경우 판매가/즉시할인 변경이 불가할 수 있습니다.',
  MSIF_YOU_CHANGE_THE_SELLING_PRICE_OF: '옵션이 등록된 상품의 판매가를 변경하실 경우 옵션 별 실제 판매가가 변경됩니다.',
  MSBATCH_CHANGE: '일괄변경',
  MSEXCEL_FORM_DOWNLOAD: '엑셀양식 다운로드',
  MSEXCEL_BATCH_REGISTRATION: '엑셀 일괄등록',
  MSCANCEL: '취소',

  MSPRODUCT_NUMBER: '상품번호',
  MSCHANGE_PRICE: '변경할 판매가',
  MSIMMEDIATE_DISCOUNT: '즉시할인',
  MSINSTANT_DISCOUNT_UNIT: '즉시할인 단위',
  MSSTART_DATE_AND_TIME_OF_IMMEDIATE_DISCOUNT: '즉시할인 시작일시',
  MSIMMEDIATE_DISCOUNT_END_DATE: '즉시할인 종료일시',
  // MSPRODUCT_NUMBER: '상품번호',
  // MSCHANGE_PRICE: '변경할 판매가',
  // MSIMMEDIATE_DISCOUNT: '즉시할인',
  // MSINSTANT_DISCOUNT_UNIT: '즉시할인 단위',
  // MSSTART_DATE_AND_TIME_OF_IMMEDIATE_DISCOUNT: '즉시할인 시작일시',
  // MSIMMEDIATE_DISCOUNT_END_DATE: '즉시할인 종료일시',
  MSRESULT: '결과',
  MSBATCH_CHANGE_RESULT: '일괄변경 결과',
  MSUPLOAD_FAILED_THE_MAXIMUM_NUMBER_OF: '업로드 실패 : 변경가능 최대 상품수 500개 초과',
  // MSBATCH_CHANGE_RESULT: '일괄변경 결과',
  MSUPLOAD_FAILED_BADLY_FORMATTED_FILE: '업로드 실패 : 잘못된 형식의 파일입니다.',
  MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSBATCH_CHANGE_RESULT: '일괄변경 결과',
  // MSBATCH_CHANGE_RESULT: '일괄변경 결과',
  MSUPLOAD_FAILED_NO_INPUT_VALUE: '업로드 실패 : 입력값 없음',
  MSSUCCESS: '성공',
  INPUT_ERROR: '입력형식이 잘못되었습니다.',
  // MSFAILURE: '실패',
  // MSFAILURE: '실패',
  // MSBATCH_CHANGE_RESULT: '일괄변경 결과'
});
